export enum CacheKeys {
  FEE_ITEM_TYPES = 'FEE_ITEM_TYPES',
  TRUCK_V1 = 'TRUCK_V1',
  TRAILER_V1 = 'TRAILER_V1',
  STATEMENT = 'STATEMENT',
  LOGGED_IN_USER = 'LOGGED_IN_USER',
}
